<template>
  <div class="interactive" :data-content-mode="showContent">




      <div id="rings">
          <div class="hud-rings-slow" id="outerRings">
              <div class="hud-ring"></div>
          </div>
          <div class="hud-rings ring-container" id="innerRings">
              <div class="hud-ring"></div>
          </div>

      </div>


      <div class="titles" :data-show="showTitles" :data-minimize="showContent">
        <h3>Collaborative imaging</h3>
        <h4>A partnership to achieve<br />more with less</h4>
      </div>





      <div class="titles" id="titles" :data-show="showTitles" style="display: none;">
          <h3>{{ appTitle }}</h3>

          <div class="title-info">
              <h4 v-if="currentCategoryTitle">{{ currentCategoryTitle }}</h4>
              <h5 v-if="currentGroupTitle">{{ currentGroupTitle }}</h5>
              <div class="notes" v-html="currentSlideNotes"></div>
          </div>

          <div class="action-msg" v-if="!showContent">
              <h4 v-html="actionMsg"></h4>
          </div>
      </div>



      <div class="slide-frame" :data-active="showContent">

          <div class="slide-content">
              <slide-loader :slide-url="currentSlideURL" :slide-data="currentSlide" :use-iframe="useIframeMode"></slide-loader>
          </div>

          <div class="close-btn" @click="onCloseClick">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.41 91.41"><title>x-icon</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_5" data-name="Layer 5"><line x1="0.71" y1="90.71" x2="90.71" y2="0.71" fill="none"  stroke-miterlimit="10" /><line x1="90.71" y1="90.71" x2="0.71" y2="0.71" fill="none" stroke-miterlimit="10"/></g></g></svg>
          </div>

      </div>

      <col-imaging-wheel-2023 v-if="showWheel" class="wheel-ui" :segments="segments" v-model="currentPosIndex" :minimize="minimizeWheel" :showing-content="showContent" @show-content="onShowContent" @hide-content="onHideContent" :data-minimize="showingContent" @interaction="emitInteraction"></col-imaging-wheel-2023>

      <WatchVideoButton  v-if="!showContent" @click.native="onWatchCiVideo" />




      <slide-deck-progress-bar v-if="showContent" class="progress-bar" @increment="onDeckIncrement" :slide-deck="currentDeck" v-model="currentPosIndex" @input="onSlideChange" @close="onCloseClick"></slide-deck-progress-bar>



        <div ref="video-container" class="ci-video" style="transform: scale(0);">
          <div class="video-box">
            <video ref="video" width="100%" playsinline controls preload="metadata" class="video" poster="../assets/black.jpg" style="opacity: 0;">
              <source :src="ciVideoUrl" type="video/mp4" />
            </video>
          </div>

          <div class="video-close-btn" @click="onCloseCiVideo">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 91.41 91.41"><title>x-icon</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_5" data-name="Layer 5"><line x1="0.71" y1="90.71" x2="90.71" y2="0.71" fill="none"  stroke-miterlimit="10" /><line x1="90.71" y1="90.71" x2="0.71" y2="0.71" fill="none" stroke-miterlimit="10"/></g></g></svg>
          </div>
        </div>


      <div class="placeholder" v-if="placeholder || placeholderVideo">
          <video width="100%" loop autoplay muted playsinline class="video" v-if="placeholderVideo" poster="../assets/black.jpg">
              <source :src="placeholderVideo" type="video/mp4" />
          </video>

          <img v-if="placeholder" :src="placeholder" />

      </div>



      <div class="hidden-box" @click="triggerLoop">

      </div>


  </div>
</template>

<script>

import ColImagingWheel2023 from "./ColImagingWheel2023";
import SlideDeckProgressBar from "./SlideDeckProgressBar";
import SlideLoader from "./SlideLoader";
import {decks} from "@/data/ringData";
import WatchVideoButton from "@/components/WatchVideoButton";

export default {
    components: {WatchVideoButton, SlideLoader, SlideDeckProgressBar, ColImagingWheel2023},
    mounted: async function(){
        //this.resetTimer();


        //window.onresize = this.onWindowResize;

        var loadedData = await fetch("data.json");
        var json;

        try {
            json = await loadedData.json();
        } catch(error){
            alert("The data.json file is incorrectly formatted. Please validate the file syntax and try again.");
        }

        if(json){
            this.ciStory = json.wheelCenter;
            this.segments = json.wheelSegments;
            this.defaultNotes = json.defaultNotes;
            this.actionMsg = json.actionMsg;
            this.appTitle = json.appTitle;
        }



        this.ciStory.segments.forEach((segment, groupIndex)=>{
            segment.posIndex =  {
                category: -1,
                    section: -1,
                    group: groupIndex,
                    page: 0
            }

            segment.slides.forEach((slide, slideIndex) => {
                slide.posIndex = {
                    category: -1,
                    section: -1,
                    group: groupIndex,
                    page: slideIndex
                }
            })
        });

        this.segments = this.indexSegments(this.segments); //indexes all navigation elements

        this.showUI();

        window.onresize = this.onWindowResize;

        ////console.log(JSON.stringify(this.ciStory));




    },

    props: {
        placeholder: {
            required: false
        },

        placeholderVideo: {
            required: false
        }
    },


    data: function(){
        return {
            defaultNotes: "",
            appTitle: "Collaborative imaging",
            actionMsg: "TOUCH THE WHEEL<br>TO LEARN MORE",
            watchCiVideo: false,
          minimizeWheel: false,
          ciVideoUrl: process.env.VUE_APP_VIDEO_URL?process.env.VUE_APP_VIDEO_URL:"https://d1q2s4ypal1q2z.cloudfront.net/ci-video-720p.mp4",

            ciStory: {
                label: "Made for Life",
                posIndex: {
                    category: -1,
                    section: -1,
                    group: 0,
                    page: 0
                },
                segments: [

                    {
                        label: "CI",

                        posIndex: {
                            category: -1,
                            section: -1,
                            group: 0,
                            page: 0
                        },
                        slides: [
                            {
                                label: "Made for Life",
                                url: "intro-made-for-life.html", useThumb: false,
                                notes: "Collaborative imaging, is a concept that embodies our new mission.\n" +
                                    "\n" +
                                    "Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.\n" +
                                    "\n" +
                                    "Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  \n" +
                                    " \n" +
                                    "AI and data analytics are at the heart of helping to achieve this goal.\n",
                                posIndex: {
                                    category: -1,
                                    section: -1,
                                    group: 0,
                                    page: 0
                                },
                            },
                            {
                                label: "CI",
                                url: "intro-collaborative-imaging1.html", useThumb: false,
                                notes: "Collaborative imaging, is a concept that embodies our new mission.\n" +
                                    "\n" +
                                    "Collaborative imaging unites multiple modalities and innovative clinical applications with integrated intelligence every step of the way.\n" +
                                    "\n" +
                                    "Our goal is simple: help our customers do their jobs better while improving patient outcomes and driving down costs.  \n" +
                                    " \n" +
                                    "AI and data analytics are at the heart of helping to achieve this goal.\n",
                                posIndex: {
                                    category: -1,
                                    section: -1,
                                    group: 0,
                                    page: 1
                                },
                            },
                            {
                                label: "AI Solutions",
                                url: "intro-ai-solutions.html", useThumb: false,
                                notes: "Nearly every aspect of medical imaging has benefited from AI’s ability to manage large volumes of complex data and derive novel insights.  Over the next decade, the integration of advancements in AI will completely revolutionize medical imaging.  At Canon Medical, we are creating this future by assembling a world-class team of imaging data scientists who work every day to craft innovative AI solutions to address the world’s most challenging imaging problems.  Our technology combats image noise, enables ultra-high resolution imaging, and streamlines and optimizes clinical workflow to enable high-quality healthcare for all.",
                                posIndex: {
                                    category: -1,
                                    section: -1,
                                    group: 0,
                                    page: 2
                                }
                            },
                            {
                                label: "Healthcare Economics",
                                url: "intro-healthcare-economics-ci.html", useThumb: false,
                                notes: "Ci touches every piece of the patients journey thought the continuum of care. Ci helps our partners navigate the economic challenges doing more with less while improving patient outcomes.",
                                posIndex: {
                                    category: -1,
                                    section: -1,
                                    group: 0,
                                    page: 3
                                }
                            },

                        ]
                    }

                ]
            },

            segments: [
                {
                    label: "OPERATIONAL",
                    active: false,
                    segments: [
                        {
                            label: "AI",
                            labelFlip: true,
                            active: false,
                            segments: [
                                {
                                    label: "Automation/nPlatform",
                                    slides: [
                                        { label: "", url: "operational-ai-hero.html", useThumb: false  },
                                        { label: "", url: "operational-ai-automation1.html", useThumb: false  },
                                        { label: "", url: "operational-ai-automation2.html", useThumb: false  },
                                    ]
                                },
                                {
                                    label: "CT / MR",
                                    slides: [
                                        { label: "", url: "operational-aice-hero.html", useThumb: false  },
                                        { label: "", url: "operational-aice1.html", useThumb: false  },
                                        { label: "", url: "operational-aice2.html", useThumb: false  },
                                        { label: "", url: "operational-aice3.html", useThumb: false  },
                                        { label: "", url: "operational-aice4.html", useThumb: false  },
                                        { label: "", url: "operational-aice5.html", useThumb: false  },
                                    ]
                                }
                            ]
                        },
                        {
                            label: "DATA SHARING",
                            labelFlip: true,
                            active: false,
                            segments: [
                                {
                                    label: "Vitrea/nConnection",
                                    slides: [
                                        { label: "", url: "operational-sharing-hero.html", useThumb: false  },
                                        { label: "", url: "operational-sharing1.html", useThumb: false  },

                                    ]
                                },
                                {
                                    label: "Vitrea/nView",
                                    slides: [
                                        { label: "", url: "operational-sharing-vitrea1.html", useThumb: false },
                                        { label: "", url: "operational-sharing-vitrea2.html", useThumb: false },
                                        { label: "", url: "operational-sharing-vitrea3.html", useThumb: false },
                                        { label: "", url: "operational-sharing-vitrea4.html", useThumb: false },
                                    ]
                                },
                            ]

                        },
                        {
                            label: "CYBERSECURITY",
                            labelFlip: true,
                            active: false,
                            segments: [
                                {
                                    label: "System/nProtection",
                                    slides: [
                                        { label: "Cybersecurity", url: "operational-security-hero.html", useThumb: false },
                                        { label: "Expertise", url: "operational-security-system-canon1.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Canon/nCybersecurity",
                                    slides: [

                                        { label: "Solutions", url: "operational-security-system-canon2.html", useThumb: false },

                                    ]
                                },
                                { label: "Installed/nBase",
                                    slides: [
                                        { label: "Solutions", url: "operational-security-system-canon3.html", useThumb: false },

                                    ]
                                }
                            ]
                        },
                    ]
                },
                {
                    label: "FINANCIAL",
                    active: false,
                    segments: [
                        {
                            label: "SERVICE",
                            active: false,
                            segments: [
                                {
                                    label: "Innervision",
                                    slides: [
                                        { label: "", url: "financial-service-innervision1.html", useThumb: true  },
                                        { label: "eWatch", url: "financial-service-innervision2.html", useThumb: true  },
                                    ]
                                },
                                {
                                    label: "360/nConnect",
                                    slides: [
                                        { label: "", url: "financial-service-360.html", useThumb: true  },
                                    ]
                                },
                            ]
                        },


                        {
                            label: "EDUCATION",
                            active: false,
                            segments: [
                                {
                                    label: "Customized/nApproach",
                                    slides: [
                                        { label: "Performance Pro", url: "financial-education-customized.html", useThumb: false  },
                                    ]
                                },
                            ]

                        },

                        {
                            label: "ANALYTICS",

                            active: false,
                            segments: [
                                {
                                    label: "Vitrea/nIntelligence",
                                    slides: [
                                        { label: "Overview", url: "financial-analytics1.html", useThumb: false  },
                                        { label: "Answers", url: "financial-analytics2.html", useThumb: false  },
                                        { label: "Analytics", url: "financial-analytics-intelligence1.html", useThumb: false  },
                                        { label: "Benefits", url: "financial-analytics-intelligence2.html", useThumb: false  },
                                    ]
                                },
                                {
                                    label: "Dashboards",
                                    slides: [
                                        { label: "Monitor Performance", url: "financial-analytics-dashboards.html", useThumb: false  },
                                        { label: "Made Possible", url: "intro-collaborative-imaging-hero.html", useThumb: false  },
                                    ]
                                },
                            ]

                        },

                    ]
                },
                {
                    label: "CLINICAL",
                    active: false,
                    segments: [
                        {
                            label: "NEUROLOGY",
                            active: false,
                            segments: [
                                {
                                    label: "Scan",
                                    slides: [
                                        { label: "", url: "clinical-stroke-hero.html", useThumb: false },
                                        { label: "", url: "clinical-stroke-scan1.html", useThumb: false },
                                        { label: "CT", url: "clinical-stroke-scan2.html", useThumb: false },
                                        { label: "MR", url: "clinical-stroke-scan3.html", useThumb: false },
                                        { label: "UL", url: "clinical-stroke-scan4.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Diagnose",
                                    slides: [
                                        { label: "CT", url: "clinical-stroke-diagnose1.html", useThumb: false },
                                        { label: "MR", url: "clinical-stroke-diagnose2.html", useThumb: false },
                                        { label: "Angiography", url: "clinical-stroke-diagnose3.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Treat",
                                    slides: [
                                        { label: "Angio-CT", url: "clinical-stroke-treat1.html", useThumb: false },
                                    ]
                                }
                            ]

                        },
                        {
                            label: "CARDIOLOGY",
                            active: false,
                            segments: [
                                {
                                    label: "Scan",
                                    slides: [
                                        { label: "", url: "clinical-heart-hero.html", useThumb: false },
                                        { label: "CI Overview", url: "clinical-heart-scan1.html", useThumb: false },
                                        { label: "CT", url: "clinical-heart-scan2.html", useThumb: false },
                                        { label: "MR", url: "clinical-heart-scan3.html", useThumb: false },
                                        { label: "US", url: "clinical-heart-scan4.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Diagnose",
                                    slides: [
                                        { label: "US", url: "clinical-heart-diagnose1.html", useThumb: false },
                                        { label: "HIT", url: "clinical-heart-diagnose2.html", useThumb: false },
                                        { label: "MR", url: "clinical-heart-diagnose3.html", useThumb: false },
                                        { label: "US", url: "clinical-heart-diagnose4.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Treat",
                                    slides: [
                                        { label: "Angiography", url: "clinical-heart-treat1.html", useThumb: false },
                                        { label: "CT", url: "clinical-heart-treat2.html", useThumb: false },
                                        { label: "US", url: "clinical-heart-treat3.html", useThumb: false },
                                    ]
                                }
                            ]

                        },
                        {
                            label: "ONCOLOGY",
                            active: false,
                            segments: [
                                {
                                    label: "Scan //nDiagnose",
                                    slides: [
                                        { label: "", url: "clinical-liver-hero.html", useThumb: false  },
                                        { label: "Workflow", url: "clinical-liver-scan-diagnose.html", useThumb: false  },
                                    ]
                                },
                                {
                                    label: "Treat",
                                    slides: [
                                        { label: "4D CT", url: "clinical-liver-treat1.html", useThumb: false },
                                        { label: "TACE", url: "clinical-liver-treat2.html", useThumb: false},
                                    ]
                                }
                            ]
                        },
                        {
                            label: "MSK",
                            active: false,
                            segments: [
                                {
                                    label: "Scan",
                                    slides: [
                                        { label: "", url: "clinical-msk-hero.html", useThumb: false },
                                        { label: "CT", url: "clinical-msk-scan1.html", useThumb: false },
                                        { label: "MR", url: "clinical-msk-scan2.html", useThumb: false },
                                        { label: "US", url: "clinical-msk-scan3.html", useThumb: false },
                                    ]
                                },
                                {
                                    label: "Diagnose",
                                    slides: [
                                        { label: "4D CT", url: "clinical-msk-diagnose1.html", useThumb: false },
                                        { label: "MR", url: "clinical-msk-diagnose2.html", useThumb: false },
                                    ]
                                },
                            ]
                        },
                    ]
                }
            ],

            currentPage: 0,
            idleTimer: undefined,
            countIntervalTimer: undefined,
            countdown: 15,
            idleSeconds: 15,

            wheelPos: "c", //c - center, bl - bottomright, etc

            currentPosIndex: { deck: "", category: -1, section: -1, group: -1, page:-1 }, //{ category: 0, section: 0, group: 0, page: 0 } controls wheel and progress bar selections
            showContent: false,

            showWheel: false,
            showTitles: false,
        }
    },

    computed: {

        currentCategoryTitle: function(){

            if(this.currentPosIndex.category > -1){

                return this.segments[this.currentPosIndex.category].label + "";

            }

            return ""
        },

        currentGroupTitle: function(){
            if(this.currentDeck){

                return this.currentDeck.label;

            }else if((this.currentPosIndex.category > -1) && (this.currentPosIndex.section > -1)){
                return this.segments[this.currentPosIndex.category].segments[this.currentPosIndex.section].label;
            }

          return ""
        },

        currentSlideNotes: function(){
            if(this.currentSlide){

                return this.currentSlide.notes;

            }else{

                return this.defaultNotes;


                //return `<p>Collaborative imaging unites multiple modalities, innovative clinical applications using integrated intelligence every step of the patient care cycle to help our customers improve patient outcomes and reduce costs.</p><p>AI and data analytics are the core in helping to achieve this goal.</p>`
            }


        },

        currentSlide: function(){
            if(this.currentDeck) {
                let slide = this.currentDeck.slides[this.currentPosIndex.page];
                return slide;
            }

            return null

        },

        currentSlideURL: function(){


            if(this.currentSlide){





                    if(this.currentSlide.useThumb){
                        if(this.currentSlide.url){
                            return (this.currentSlide.url.split(".")[0] + ".jpg");
                        }

                    }else{
                      if(window.frames[0]){
                        window.frames[0].stop();
                        console.log("stop")
                      }

                        return this.currentSlide.url;
                    }



            }

            return null
        },

        useIframeMode: function(){


            if(this.currentSlide){
                return this.currentSlide.iframe;
            }

            return null
        },

        currentDeck: function(){

          //console.log("currentDeck", this.currentPosIndex)
          //console.log(decks.mainStory)
            if(this.showContent){


                if(this.currentPosIndex?.deck){
                  let deck = decks[this.currentPosIndex.deck];
                  if(deck){
                    return deck;
                  }
                }

                // if(this.currentPosIndex){
                //     if(this.currentPosIndex.category > -1){
                //         return this.segments[this.currentPosIndex.category].segments[this.currentPosIndex.section];
                //     }else if (this.currentPosIndex.group > -1){
                //         return this.ciStory;
                //     }
                //
                // }

            }


            return null;
        },

        showingContent: function(){
           if (this.currentDeck && this.currentDeck.slides.length) {
               return true;
           }else{
               return false;
           }
        }


    },

    methods: {

      onWatchCiVideo: function(){
        //console.log("watch video")
        this.minimizeWheel = true;
        let video = this.$refs["video"];
        let videoContainer = this.$refs["video-container"];

        if(video){
          this.$tween.to(videoContainer, 0.3, {scale:1.0})
          this.$tween.to(video, 0.3, {opacity: 1, onComplete: ()=>{
              video.play();
            }})
          //video.play();
        }
      },

      onCloseCiVideo: function(){
        //console.log("close video")

        let video = this.$refs["video"];
        let videoContainer = this.$refs["video-container"];
        if(video){

          this.$tween.to(videoContainer, 0.3, {scale:0})
          this.$tween.to(video, 0.3, {opacity: 0, onComplete: ()=>{
              //console.log("pause, set to zero");
              video.pause();
            video.currentTime = 0;
            }})
          this.minimizeWheel = false;
          //video.play();
        }




      },


      toggleFullscreen: function(){
        //console.log("wheel full");
        this.$emit('fullscreen');
      },

        emitInteraction: function(){
            this.$emit("interaction");
        },

        onWindowResize: function(){
            //console.log("resize");
        },


        triggerLoop: function(){
            ////console.log("trigger looop");
            this.$emit("trigger-loop");
        },

        showUI: function(){
            let rings = document.getElementById("rings");
            //console.log("showUI", rings)
            //var titles = document.getElementById("titles");


            this.emitInteraction();
            this.$tween.set(rings, { opacity: 0 });

            this.showWheel = true;

            setTimeout(()=>{
                this.showTitles = true;
            }, 1000)

            this.$tween.to(rings, 2.0, { opacity: 1.0, onComplete: () =>{

            } });







        },

        homePos: function(){
            return {
                category: -1,
                section: -1,
                group: -1,
                page: -1,
            }
        },

        onCloseClick: function(){
            this.showContent = false;
            this.currentPosIndex = this.homePos();
            this.emitInteraction();
        },

        onDeckIncrement: function(direction){
            //this.emitInteraction();
            if(this.currentDeck){

                var tgtPage = this.currentPosIndex.page + direction;

                if(tgtPage < 0){
                    this.showContent = false;
                  this.currentPosIndex = {
                    deck: "",
                    category: -1,
                    section: -1,
                    group: -1,
                    page: tgtPage,
                  }
                }else{

                  this.currentPosIndex = {
                    deck: this.currentDeck.id,
                    category: -1,
                    section: -1,
                    group: -1,
                    page: tgtPage,
                  }

                }




            }
        },

        indexSegments: function(segments){
            segments.forEach((category, catIndex) => {
                category.posIndex = { category: catIndex, section: -1, group: -1, page: -1 }
                category.segments.forEach((section, sectionIndex) => {
                    section.posIndex = { category: catIndex, section: sectionIndex, group: -1, page: 0 }
                    section.segments.forEach((group, groupIndex) => {
                        group.posIndex = { category: catIndex, section: sectionIndex, group: groupIndex, page: 0 }
                        group.slides.forEach((slide, slideIndex) => {
                            slide.posIndex = { category: catIndex, section: sectionIndex, group: groupIndex, page: slideIndex }
                        })
                    })
                })
            })

            return segments;
        },

        onWheelExpand: function(){
            this.wheelPos = "c";
        },

        onSlideChange: function(){
            this.emitInteraction();
        },

        onShowContent: function(){
            ////console.log("show content");
            this.showContent = true;

        },

        onHideContent: function(){
            this.posIndex = {
                category: -1,
                section: -1,
                group: -1,
                page: -1
            }



        },



        onBubbleClick: function(){





            //this.currentDeck = this.segments[index.category].segments[index.section];


            // var slideIndex = 0; //get first slide position for group within slides
            // if(index.group){
            //     slideIndex = this.currentDeck.segments.reduce((slidePos, group, groupIndex) => {
            //         if(index.group > groupIndex){
            //             slidePos += group.slides.length;
            //         }
            //
            //         return slidePos;
            //     }, 0)
            // }
            //
            // this.currentPage = slideIndex;





            this.wheelPos = "bl";


        },

        onBoxClick: function(slide){
            this.currentPage = slide.id;
            if(this.$socket){
                this.$socket.emit('interaction');
            }

            //this.resetTimer();
        },

        resetTimer: function(){
            if(this.idleTimer) {
                clearTimeout(this.idleTimer);
            }

            this.idleTimer = setTimeout(()=>{ this.onIdle(); }, this.idleSeconds * 1000);

            this.countdown = this.idleSeconds;
            if(!this.countIntervalTimer){
                this.countIntervalTimer = setInterval(this.onCountdown, 1000);
            }

        },

        onIdle: function(){
            if(this.$socket){
                this.$socket.emit("forceidle");
            }

        },

        onWake: function(){

        },

        onCountdown: function(){
            this.countdown = this.countdown - 1;
        }

    }

}
</script>

<style>

    @keyframes rotateloop {

        0% {
            transform: rotate(0deg);
        }



        100% {
            transform: rotate(359deg);
        }

    }

    @keyframes rotateloopReverse {

      0% {
        transform: rotate(0deg);
      }



      100% {
        transform: rotate(-359deg);
      }

    }

    @keyframes fadeloop {

        0% {
            opacity: 100%;
        }

        50% {
            opacity: 30%;
        }

        100% {
            opacity: 100%;
        }

    }

    .zoom-reveal-enter-active, .zoom-reveal-leave-active {
        transform: scale(1.0);
        opacity: 1.0;
        transition: all .5s;
    }
    .zoom-reveal-enter, .zoom-reveal-leave-to /* .fade-leave-active below version 2.1.8 */ {
        transform: scale(0);
        opacity: 0;
    }

    .interactive {
        background-color: black;
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        top: 0;
        left: 0;
        overflow: hidden;

        color: white;
        font-family: "Myriad", Arial, "Helvetica Neue", Helvetica, sans-serif;
        -webkit-font-smoothing: antialiased;

    }

    .slide {
       position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        user-select: none;

    }



    .wheel-ui {
        position: absolute;
        width: 45em;
        height: 45em;

        transform: scale(1.0);
        left: calc(50% - 22.5em);
        bottom: calc(50% - 22.5em);






    }

    .hud-ring {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-size: contain;
        background-image: url(../assets/hud-rings-2.png);

    }



    .hud-rings-slow {
        position: absolute;
        width: 60em;
        height: 60em;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        opacity: 0.15;
        transition: all 1.0s;
    }

    .hud-rings-slow .hud-ring {

        animation: rotateloop 120s linear infinite;

    }

    .hud-rings-slow-reverse .hud-ring {

      animation: rotateloopReverse 120s linear infinite;

    }

    .hud-rings {
        position: absolute;
        width: 40em;
        height: 40em;
        transform: translate(-50%,-50%);
        top: 50%;
        left: 50%;
        opacity: 0.3;
        transition: all 0.5s;
    }

    .hud-rings .hud-ring {

        animation: rotateloop 60s linear infinite;

    }

    .interactive[data-content-mode="true"] .hud-rings {
        width: 50em;
        height: 50em;
        opacity: 0.10;

    }

    .interactive[data-content-mode="true"] .hud-rings-slow {
        width: 70em;
        height: 70em;
        opacity: 0.15;

    }


    .wheel-ui[data-minimize="true"]{

        transform: scale(0.4);
        bottom: -12em;
        left: -11em;
    }

    .progress-bar {
        box-sizing: border-box;
        position: absolute;
        bottom: 4.5em;
        left: 22em;
        right: 11em;
    }

    .slide-frame {
        position: absolute;
        top: 6em;
        left: 6em;
        right: 6em;
        bottom: 10em;


        opacity: 0;

        transition: all 1.0s;
        transition-delay: 0.1s;
    }

    .slide-frame[data-active="true"] {
        position: absolute;
        top: 5em;
        left: 5em;
        right: 6em;
        bottom: 10em;


        opacity: 1.0;
    }

    .titles {

        transform-origin: top left;
        width: 100%;

        position: absolute;
        top: 10em;
        left: 5em;

        padding-bottom: 2em;
        padding-top: 2em;
        user-select: none;

        border-left: 4px solid white;
        padding-left: 1.5em;

        opacity: 0;

        transition: all 1.0s;
      pointer-events: none;
    }

    .titles[data-show="true"]{
        opacity: 1.0;
        top: 5em;
    }

    .titles h3 {
      font-size: 2.5em;
    }

    .titles h4 {
      font-size: 1.5em;

    }

    .titles h3, .titles h4 {
        margin-bottom: 0.5em;
    }

    .titles .notes {
        font-size: 0.8em;
        padding-top: 1em;
        line-height: 1.3em;

    }

    .titles .notes .smaller {
      font-size: 0.9em;
      line-height: 1.4em;


    }

    .titles .notes p.smaller {

    }

    .action-msg {

        margin-top: 2em;
        opacity: 1.0;
        animation: fadeloop 2s infinite;
        transition: opacity 0.5s;
        color: var(--brand-red);



    }

    .interactive[data-content-mode="true"] .action-msg {
        opacity: 0;
        animation: none;
        display: none;
    }

    .action-msg .action-arrow {
        position: absolute;
        width: 2em;
        height: 2em;
        transform: rotate(215deg);
        top: -1.6em;
        left:-1.8em;



    }


    .slide-frame .slide-content {

        position: absolute;
        left: calc(15% + 4em);
        width: calc( 85% - 3em);
        top: 0;
        padding-bottom: calc((85% - 3em) * (9/16));

        /*box-sizing: border-box;*/
        border: 1px solid rgba(255, 255, 255, 0.5);




        transform: scale(0);

        transition: all 0.3s;
        transition-delay: 0.3s;



    }

    .slide-frame[data-active="true"] .slide-content {
        transform: scale(1.0);

    }

    .slide-frame .slide-content .slide {
        box-sizing: border-box;



    }

    .slide-frame .close-btn {
        position: absolute;
        width: 2.5em;
        height: 2.5em;
        right: -2.5em;
        top: -1.5em;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 2px solid white;
        border-radius: 100%;
        background-color: black;

    }

    .close-btn svg {
        stroke: white;
        width: 1.0em;
        stroke-width: 8px;
    }

    .hidden-box {
        position: absolute;
        top: 0;
        left: 0;
        width: 5em;
        height: 5em;
        background-color: transparent;


    }

    .placeholder {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;


    }

    .placeholder img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }



    .titles[data-minimize="true"]{
      transform: scale(0.5);
    }

    .ring-gradient {
      position: absolute;
      top: 0;
      height: 0;
      width: 100vw;
      height: 100vh;
      background: radial-gradient(transparent 0%, transparent 30vw, black 60vw );
    }

    .ci-video {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    .ci-video .video-box {
      border: 1px solid white;
      transform: scale(0.9);
      background-color: black;
    }


    .video-close-btn {
      position: absolute;
      width: 2.5em;
      height: 2.5em;
      right: 3.5em;
      top: 1.5em;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 2px solid white;
      border-radius: 100%;
      background-color: black;

    }

    .video-close-btn svg {
      stroke: white;
      width: 1.0em;
      stroke-width: 8px;
    }









</style>